<template>
  <div id="basic-info" class="my-3 text-center">
    <div class="size-18 fw-bold mb-3 pt-4">プロフィール（基本情報）</div>
    <div class="d-flex align-items-center justify-content-center">
      <span class="tag-thirdly size-10 me-2">必須</span>
      <span class="size-12">の項目を入力してください。</span>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <span class="size-12">スカウト、応募/面談に必要な項目になります。</span>
    </div>
  </div>
  <div class="col-12 bg-white-primary mx-auto">
    <Platform />
    <NameBasic />
    <DateOfBirth />
    <Gender />
    <Address />
    <Phone />
    <Married />
    <SchoolCategory />
    <EducationInfo />
    <OtherEducationalBackgrounds />
    <NativeLanguage />
    <Languages />
    <Income />
    <QualificationsDescription />
    <SpecialRemarks />
  </div>
</template>

<script setup lang="ts">
import Platform from './Platform.vue';
import NameBasic from './NameBasic.vue';
import DateOfBirth from './DateOfBirth.vue';
import Gender from './Gender.vue';
import Address from './Address.vue';
import Phone from './Phone.vue';
import Married from './Married.vue';
import SchoolCategory from './SchoolCategory.vue';
import EducationInfo from './EducationInfo.vue';
import OtherEducationalBackgrounds from './OtherEducationalBackgrounds.vue';
import NativeLanguage from './NativeLanguage.vue';
import Languages from './Languages.vue';
import Income from './Income.vue';
import QualificationsDescription from './QualificationsDescription.vue';
import SpecialRemarks from './SpecialRemarks.vue';
</script>
